<template>
  <div class="top">
    <div class="top_data">
      <a-avatar :size="70" :src="'https://static.daoba.com/darkSportsLogo/'+ programId + '.png'" :style="{ backgroundColor: '#ffffff00'}">
        <div style="height: 70px; width: 70px;background: #ffffff;display: flex;align-items: center; justify-content: center;">
          <div style="border-radius: 50%; height: 40px; width: 40px; display: flex;align-items: center; justify-content: center; background: #333333;">
            <div style="border-radius: 50%; height: 36px; width: 36px; display: flex;align-items: center; justify-content: center; border: 1px solid #ffffff; background: #333333;color: #ffffff;font-weight: bold;font-size: 18px">
              {{programName.substring(0, 1)}}
            </div>
          </div>
        </div>
      </a-avatar>
      <div >
        <div class="main_name">{{ programEnName.toUpperCase() }}</div>
        <div class="sub_name">DAOBA MATCH</div>
      </div>
      <div class="sys_name">{{ programName }}比赛系统</div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      programId: this.$route.query.programId,
      programName: this.$route.query.programName,
      programEnName: this.$route.query.programEnName
    }
  },
  watch: {
    '$route.query.programId': {
      handler (newValue, oldValue) {
        if (newValue != this.programId) {
          this.programId = this.$route.query.programId
          this.programName = this.$route.query.programName
          this.programEnName = this.$route.query.programEnName
          this.$forceUpdate()
        }
      },
      deep: true
    }
  }
}
</script>
<style scoped lang="scss">
  .top {
    padding: 10px 0px;
    border-bottom: 1px solid #bfbfbf;
    .top_data {
      width: 1200px;
      margin: auto;
      text-align: left;
      display: flex;
      align-items: center;
      img {
        height: 70px;
      }
      .main_name {
        font-size: 16px;
        font-weight: bold;
      }
      .sub_name {
        font-size: 12px;
        font-weight: bold;
      }
      .sys_name {
        margin-left: 20px;
        font-weight: bold;
        font-size: 24px;
        color: #333333;
      }
    }
  }
  /deep/ .ant-avatar-string {
    line-height: 80px;
    transform: scale(1) translateX(-50%);
    opacity: 1 !important;
  }
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/product/components/Top.vue